import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import moment from "moment";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { PeriodSelectionWithCustom, DisplaySearchCriteria } from "../../../components/TapUi/index";
import TapSelect from "../../../components/ui/TapSelect";
import Helmet from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import TapHelper from '../../../services/TapHelper';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import ProgressBarComparison from './ProductivityComparisonPeriodGraph';
import DateService from '../../../services/DateService';
import DownloadFile from "../../../services/DownloadFile";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import PageHeader from '../../includes/PageHeader';

const AttachmentWiseProductivityReport = (props) => {
    const setting                       =    useSelector(state => state.app.setting)

    const initListingData = {
        loading                         :    false,
        show                            :    false,
        items                           :    [],
        page                            :    1
    };

    const initFormData = {
        show                            :    true,
        form_data_loaded                :    false,
        loading                         :    false,
        downloading                     :    false,
         search_asset_ids               :      [],
        site_group_ids                  :      [],
        search_site_ids                 :      [],
        asset_group_ids                 :      [],
        search_asset_type_ids           :      [],
        search_asset_matrix_ids         :      [],
        date_range                      :      '',
        search_activities               :      [],
        search_units                    :      [],
        search_material_ids             :      [],
        search_attachment_ids1          :      [],
        search_attachment_ids2          :      [],
        search_attachment_ids3          :      [],
        date_range_start                :      '',
        date_range_end                  :      '',
        all_periods                     :    [],
        all_asset_types                 :    [],
        all_user_sites                  :    [],
        all_asset_matrix                :    [],
        all_site_groups                 :    [],
        all_asset_groups                :    [],
        all_activities                  :    [],
        all_units                       :    [],
        all_materials                   :    [],
        all_attachments                 :    []
    };

    const formDataLabel = {
        search_asset_ids                :   'Assets : ',
        site_group_ids                  :   'Site Groups : ',
        search_site_ids                 :   'Sites : ',
        asset_group_ids                 :   'Asset Type Groups : ',
        search_asset_type_ids           :   'Asset Type : ',
        search_asset_matrix_ids         :   'Asset Matrix : ',
        date_range                      :   'Period : ',
        search_activities               :   'Activities : ',
        search_units                    :   'Units : ',
        search_material_ids             :   'Materials : ',
        search_attachment_ids1          :   `${setting?.attachment_name} 1 : `,
        search_attachment_ids2          :   `${setting?.attachment_name} 2 : `,
        search_attachment_ids3          :   `${setting?.attachment_name} 3 : `,
    };

    const access_token                  =    useSelector(state => state.auth.access_token);
    const iam_asset_types               =    useSelector(state => state.app?.asset_type || []);
    const iam_user_sites                =    useSelector(state => state.app?.user_sites || []);
    const iam_asset_matrix              =    useSelector(state => state.app?.asset_matrix || []);
    const asset_groups                  =    useSelector(state => state.app?.asset_groups || []);
    const all_periods                   =    useSelector(state => {
        const periods                   =    state.app?.all_periods || [];
        return [...periods, { key: 'custom', display: 'Custom Date Range' }];
    });
    const site_groups                   =    useSelector(state => state.app?.site_groups || []);
    const report_listing                =    useSelector(state => state.app?.report_listing || []);


    const [criteriaHeight, setCriteriaHeight] = useState(0);
    const [searchedAssets, setSearchedAssets] = useState([]);
    const [listingData, setListingData] = useState({ ...initListingData });
    const [formData, setFormData] = useState({ ...initFormData });
    const [searchedElems, setSearchedElems] = useState([]);
    const [reportName, setReportName] = useState({});

    const criteriaRef = useRef(null);
    const formDataUrl = IAM_API_BASE_URL_2 + '/report/productivity-report';
    const reportUrl = IAM_API_BASE_URL_2 + '/report/productivity_attachment_wise';

    useEffect(() => {
        initializeReport();
    }, []);

    useEffect(() => {
        updateCriteriaHeight();
        if (formData.show && !formData.form_data_loaded) {
            loadFormData();
        }
    }, [formData.show]);

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height);
            }
        }
    };

    const initializeReport = () => {
        const report_name = props?.location?.pathname ? props.location.pathname.split('/')[2] : '';
        const reportData = report_listing.length > 0 ? report_listing.filter(d => d.key === report_name) : [];
        setReportName(reportData.length > 0 ? reportData[0] : null);
        
         const mappedAssetTypes = iam_asset_types ? iam_asset_types.map((at) => ({ value: at.id, label: at.asset_type_name })) : [];
        const mappedUserSites = iam_user_sites ? iam_user_sites.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })) : [];
        const mappedAssetMatrix = iam_asset_matrix ? iam_asset_matrix.map(am => ({ value: am.id, label: am.asset_matrix_unique_id })) : [];
        const mappedAssetGroups = asset_groups && asset_groups.length > 0 ? asset_groups.map(oc => ({ value: oc.id, label: oc.name, linked_asset_types: oc.asset_type_ids })) : [];
        const mappedSiteGroups = site_groups ? site_groups.map(oc => ({ value: oc.id, label: oc.name, linked_sites: oc.site_ids })) : [];
        setFormData(prev => ({
            ...prev,
            all_asset_types: mappedAssetTypes,
            all_user_sites: mappedUserSites,
            all_asset_matrix: mappedAssetMatrix,
            all_asset_groups: mappedAssetGroups,
            all_site_groups: mappedSiteGroups,
            all_periods: all_periods,
            date_range: '',
            show: true
        }));
    };

    const loadFormData = () => {
        setFormData(prev => ({ ...prev, loading: true }));
        HttpAPICall.withAthorization('GET', formDataUrl, access_token, { action: 'formData' }, null, (response) => {
            const respData = response.data;
            setFormData(prev => ({
                ...prev,
                form_data_loaded: true,
                loading: false,
                all_activities: respData.activity_name ? respData.activity_name.map((s) => ({ value: s.id, label: s.activity_name })) : [],
                all_units: respData.uom ? respData.uom.map((s) => ({ value: s.id, label: s.measuring_unit })) : [],
                all_materials: respData.materials ? respData.materials.map((s) => ({ value: s.id, label: s.material_name })) : [],
                all_attachments: respData.attachments ? respData.attachments.map((s) => ({ value: s.id, label: s.name })) : []
            }));
        }).catch(() => {
            setFormData(prev => ({ ...prev, loading: false }));
        });
    };

    const toggleFilterForm = () => {
        setFormData(prev => ({ ...prev, show: !prev.show }));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    };

    const closeReport = () => {
        props.history.push('/report');
    };

    
    const submitSearchFormHandler = (e) => {
        e.preventDefault();
        
        const searchedElems = [];
        Object.keys(formDataLabel).forEach(key => {
            const value = formData[key];
            if (value && (Array.isArray(value) ? value.length > 0 : value.toString().length > 0)) {
                let displayValue = value;
                if (key === 'search_asset_ids') {
                    displayValue = searchedAssets.map(s => s.display_label).join(', ');
                } else if (key === 'asset_group_ids') {
                    displayValue = formData.all_asset_groups.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'search_asset_type_ids') {
                    displayValue = formData.all_asset_types.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'site_group_ids') {
                    displayValue = formData.all_site_groups.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'search_site_ids') {
                    displayValue = formData.all_user_sites.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'search_asset_matrix_ids') {
                    displayValue = formData.all_asset_matrix.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'search_activities') {
                    displayValue = formData.all_activities.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'search_units') {
                    displayValue = formData.all_units.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'search_material_ids') {
                    displayValue = formData.all_materials.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key.includes('search_attachment_ids')) {
                    displayValue = formData.all_attachments.filter(s => value.includes(s.value)).map(s => s.label).join(', ');
                } else if (key === 'date_range') {
                    if (value === 'custom') {
                        const start_range = moment(formData.date_range_start).format('DD-MMM-YYYY');
                        const end_range = moment(formData.date_range_end).format('DD-MMM-YYYY');
                        displayValue = `Custom Date Range (${start_range} - ${end_range})`;
                    } else {
                        const period = formData.all_periods.find(p => p.key === value);
                        displayValue = period ? (period.display_with_date || period.display) : value;
                    }
                }

                if (displayValue) {
                    searchedElems.push(formDataLabel[key] + `<b>${displayValue}</b>`);
                }
            }
        });

        setSearchedElems(searchedElems);
        setFormData(prev => ({ ...prev, show: false }));
        loadListingData(1);
    };
    const buildPayload = (action = 'data') => {
        const baseParams = TapHelper.pick(formData, [
            'site_group_ids',
            'search_site_ids',
            'asset_group_ids',
            'search_asset_type_ids',
            'search_asset_matrix_ids',
            'search_activities',
            'search_units',
            'search_material_ids',
            'search_asset_ids',
            'date_range',
            'date_range_start',
            'date_range_end'
        ]);

        const attachments_ids = [
            formData.search_attachment_ids1,
            formData.search_attachment_ids2,
            formData.search_attachment_ids3
        ].filter(attachment => attachment && attachment.length > 0);

        return {
            ...baseParams,
            show_filter: formData.show,
            attachments_ids: attachments_ids,
            action: action
        };
    };

    const loadListingData = (page = 1) => {
        setListingData(prev => ({ ...prev, loading: true, show: true, page: page }));
        
        const payload = {
            page: page,
            ...buildPayload('data')
        };
  
        HttpAPICall.withAthorization('POST', reportUrl, access_token, {}, payload, (response) => {
            setListingData(prev => ({
                ...prev,
                items: response.data || [],
                loading: false
            }));
        }).catch(() => {
            setListingData(prev => ({ ...prev, loading: false }));
        });
    };

    const reportDownloadHandler = () => {
        setFormData(prev => ({ ...prev, downloading: true }));
        const payload = buildPayload('download');
        HttpAPICall.withAthorization('POST', reportUrl, access_token, {}, payload, (response) => {
            DownloadFile.file(response.data.file_path);
        }).then(() => {
            setFormData(prev => ({ ...prev, downloading: false }));
        }).catch(() => {
            setFormData(prev => ({ ...prev, downloading: false }));
        });
    };


    const tapSelectChange = (selectedOption, fieldName) => {
        const value = selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [];
        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
    const topRightHeaderJsx = () => (
        <div className="text-end ">
            <button type="button" onClick={toggleFilterForm} className="btn btn-secondary">
                Change Filter
            </button>
            {listingData.show && (
                <button 
                    type="button" 
                    disabled={listingData.loading || formData.downloading} 
                    className="btn btn-secondary ms-1" 
                    onClick={reportDownloadHandler}
                >
                    <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                    {formData.downloading && (
                        <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />
                    )}
                </button>
            )}
            <button type="button" className="btn btn-secondary ms-1" onClick={closeReport}>
                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
            </button>
        </div>
    );

    const filterFormJsx = () => (
        <form onSubmit={submitSearchFormHandler} className="p-3 filter_form">
            <div className="row mb-3">
                <label className="col-sm-3 col-form-label col-form-label-sm text-end">Asset</label>
                <div className="col-sm-8">
                    <InputAssetSearch
                        changeEvent={(selectedOption) => {
                            const selectedAssets = selectedOption || [];
                            setSearchedAssets(selectedAssets);
                            setFormData(prev => ({
                                ...prev,
                                search_asset_ids: selectedAssets.map(a => a.value)
                            }));
                        }}
                        isMulti={true}
                        menuPlacement="bottom"
                        value={searchedAssets.map(a => ({ ...a, label: a.display_label }))}
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Asset Type Group</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_asset_groups}
                        changeEvent={(selectedOption) => {
                            setFormData(prev => ({
                                ...prev,
                                asset_group_ids: selectedOption ? selectedOption.map(o => o.value) : [],
                                search_asset_type_ids: selectedOption ? selectedOption.flatMap(s => s.linked_asset_types) : []
                            }));
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.all_asset_groups.filter(s => formData.asset_group_ids.includes(s.value))}
                        placeholder="Select Asset Type Group"
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_asset_types}
                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_asset_type_ids')}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={(formData.all_asset_types || []).filter(s => formData.search_asset_type_ids.includes(s.value))}
                        
                        placeholder="Select Asset Type"
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Asset Matrix</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_asset_matrix}
                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_asset_matrix_ids')}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                         value={(formData.all_asset_matrix || []).filter(s => formData.search_asset_matrix_ids.includes(s.value))}
                        placeholder="Select Asset Matrix"
                    />
                </div>
            </div>

            <div className="row mb-3">
                <label className="col-sm-3 col-form-label text-end">Asset Site Group</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_site_groups}
                        changeEvent={(selectedOption) => {
                            setFormData(prev => ({
                                ...prev,
                                site_group_ids: selectedOption ? selectedOption.map(o => o.value) : [],
                                search_site_ids: selectedOption ? selectedOption.flatMap(s => s.linked_sites) : []
                            }));
                        }}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.all_site_groups.filter(s => formData.site_group_ids.includes(s.value))}
                        placeholder="Select Site Group"
                    />
                </div>
            </div>

            <div className="row mb-3">
                <label className="col-sm-3 col-form-label text-end">Asset Site Name</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_user_sites}
                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_site_ids')}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.all_user_sites.filter(s => formData.search_site_ids.includes(s.value))}
                        placeholder="Select Sites"
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Activities</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_activities}
                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_activities')}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.all_activities.filter(s => formData.search_activities.includes(s.value))}
                        placeholder="Select Activities"
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Units</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_units}
                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_units')}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.all_units.filter(s => formData.search_units.includes(s.value))}
                        placeholder="Select Units"
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Materials</label>
                <div className="col-sm-8">
                    <TapSelect
                        options={formData.all_materials}
                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_material_ids')}
                        isSearchable={true}
                        isClearable={true}
                        isMulti={true}
                        value={formData.all_materials.filter(s => formData.search_material_ids.includes(s.value))}
                        placeholder="Select Materials"
                    />
                </div>
            </div>

            <div className="row my-3">
                <label className="col-sm-3 col-form-label text-end">Select Period</label>
                <div className="col-sm-8">
                    <PeriodSelectionWithCustom
                        periods={formData.all_periods}
                        value={formData.date_range}
                        startDate={formData.date_range_start}
                        endDate={formData.date_range_end}
                        onSelectPeriod={(period, startDate, endDate) => {
                            setFormData(prev => ({
                                ...prev,
                                date_range: period,
                                date_range_start: startDate || '',
                                date_range_end: endDate || ''
                            }));
                        }}
                    />
                </div>
            </div>
            {[1, 2, 3].map(num => (
                <div className="row my-3" key={num}>
                    <label className="col-sm-3 col-form-label text-end">
                        {setting?.attachment_name} {num > 1 ? '' : ''}
                        {num === 1 && <span className="text-danger">*</span>}
                    </label>
                    <div className="col-sm-8">
                        <TapSelect
                            options={formData.all_attachments}
                            changeEvent={(selectedOption) => tapSelectChange(selectedOption, `search_attachment_ids${num}`)}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.all_attachments.filter(s => 
                                formData[`search_attachment_ids${num}`].includes(Number(s.value))
                            )}
                            required={num === 1}
                            placeholder={`Select ${setting?.attachment_name}`}
                            menuPlacement= "top"
                        />
                    </div>
                </div>
            ))}

            <div className="row">
                <div className="pb-3 col-9 text-end">
                    <button type="submit" disabled={listingData.loading} className="btn btn-primary px-4">
                        Show Report
                    </button>
                </div>
                <hr />
            </div>
        </form>
    );

   const reportListingJsx = () => {
    const items = listingData.items || [];
    
    return (
        <>
            <div ref={criteriaRef} style={{ position: 'sticky', top: 0, background: 'white' }}>
                <DisplaySearchCriteria searchedElems={searchedElems} />
            </div>
            
            <table className="table table-bordered bg-white table-sm">
                <thead className="align-middle table-secondary" style={{ top: `${criteriaHeight}px`, position: 'sticky' }}>
                    <tr>
                        <th className="text-center" style={{ width: "20%" }}>#</th>
                        {items.map((item, index) => (
                            <th key={index} className="text-center" style={{ width: "15%" }}>
                                {item.attachments?.map(att => att.name).join(', ') || `Attachment ${index + 1}`}
                            </th>
                        ))}
                        <th className="text-center" style={{ width: "35%" }}>Graph</th>
                    </tr>
                </thead>
                <tbody>
                    {listingData.loading ? (
                        <tr><td colSpan={items.length + 2} className="text-center"><Loader /></td></tr>
                    ) : items.length === 0 ? (
                        <tr><td colSpan={items.length + 2} className="text-center">No Records Found</td></tr>
                    ) : (
                        <>
                            {['start_date', 'end_date', 'total_days', 'total_production', 'production_per_day'].map((field, idx) => (
                                <tr key={field}>
                                    <td>{field.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}</td>
                                    {items.map((item, i) => (
                                        <td className='text-end' key={i}>
                                            {field === 'start_date' && DateService.dateFormat(item.start_date)}
                                            {field === 'end_date' && DateService.dateFormat(item.end_date)}
                                            {field === 'total_days' && (item.total_days || 0)}
                                            {field === 'total_production' && (TapHelper.numberFormatter(item.total_production, 3) || 0)}
                                            {field === 'production_per_day' && 
                                                (item.total_days && (TapHelper.numberFormatter(item.total_production / item.total_days, 3) || 0))
                                            }
                                        </td>
                                    ))}
                                    <td className='text-end'></td>
                                </tr>
                            ))}

                            {/* Activity Wise Productivity */}
                            <tr><td colSpan={items.length + 2}><b>Activity Wise Productivity</b></td></tr>
                            {items.length > 0 && Array.from(new Set(
                                items.flatMap(item =>
                                    item.activity_wise_production?.map(act => 
                                        `${act.activity_name} - ${act.unit || ''} - ${act.material_name}`
                                    ) || []
                                )
                            )).map((activityKey, activityIndex) => {
                                const activity = items[0].activity_wise_production?.find(act => 
                                    `${act.activity_name} - ${act.unit || ''} - ${act.material_name}` === activityKey
                                );
                                
                                // Collect production values for all items
                                const productionValues = items.map(item => {
                                    const matched = item.activity_wise_production?.find(act =>
                                        act.activity_name === activity?.activity_name &&
                                        act.material_name === activity?.material_name
                                    );
                                    return parseFloat(matched?.production) || 0;
                                });
                                
                                // Calculate global min/max
                                const allProductions = items.flatMap(item =>
                                    item.activity_wise_production?.map(act => act.production) || []
                                );
                                const globalMin = allProductions.length ? Math.min(...allProductions) : 0;
                                const globalMax = allProductions.length ? Math.max(...allProductions) : 1;
                                
                                // Create labels for each item
                                const labels = items.map(item =>
                                    item.attachments?.map(att => att.name).join(', ') || ''
                                );

                                return (
                                    <tr key={activityIndex}>
                                        <td>{activityKey}</td>
                                        {items.map((item, i) => {
                                            const matched = item.activity_wise_production?.find(act =>
                                                act.activity_name === activity?.activity_name &&
                                                act.material_name === activity?.material_name
                                            );
                                            return <td className='text-end' key={i}>{
                                                (TapHelper.numberFormatter(matched?.production, 3) || 0)
                                            }</td>;
                                        })}
                                        <td className='text-end'>
                                            <ProgressBarComparison
                                                values={productionValues}
                                                unit={activity?.unit || ''}
                                                minValue={globalMin}
                                                maxValue={globalMax}
                                                labels={labels}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}

                            {/* Asset Wise Productivity */}
                            <tr><td colSpan={items.length + 2}><b>Asset Wise Productivity</b></td></tr>
                            {items.length > 0 && Array.from(new Set(
                                items.flatMap(item =>
                                    item.asset_wise_production?.map(asset => asset.name) || []
                                )
                            )).map((assetName, assetIndex) => {
                                // Collect production values for all items
                                const productionValues = items.map(item => {
                                    const asset = item.asset_wise_production?.find(a => a.name === assetName);
                                    return parseFloat(asset?.production) || 0;
                                });
                                
                                // Calculate global min/max
                                const allProductions = items.flatMap(item =>
                                    item.asset_wise_production?.map(asset => asset.production) || []
                                );
                                const globalMin = allProductions.length ? Math.min(...allProductions) : 0;
                                const globalMax = allProductions.length ? Math.max(...allProductions) : 1;
                                
                                // Create labels for each item
                                const labels = items.map(item =>
                                    item.attachments?.map(att => att.name).join(', ') || ''
                                );

                                return (
                                    <tr key={assetIndex}>
                                        <td>{assetName}</td>
                                        {items.map((item, i) => {
                                            const asset = item.asset_wise_production?.find(a => a.name === assetName);
                                            return <td className='text-end' key={i}>{
                                                (TapHelper.numberFormatter(asset?.production, 3) || 0)}</td>;
                                        })}
                                        <td className='text-end'>
                                            <ProgressBarComparison
                                                values={productionValues}
                                                unit=""
                                                minValue={globalMin}
                                                maxValue={globalMax}
                                                labels={labels}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </>
                    )}
                </tbody>
            </table>
        </>
    );
};

    return (
        <ApplicationLayout>
            <Helmet><title>Attachment Wise Productivity - Report</title></Helmet>
            <PageHeader 
                title="Attachment Wise Productivity Report" 
                name={reportName?.name} 
                rightTopHeadingJsx={topRightHeaderJsx()} 
            />
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        <div className={["bg-white", formData.show ? 'tbShow' : 'tbHide'].join(" ")}>
                            {formData.loading ? <Loader /> : filterFormJsx()}
                        </div>
                        {listingData.show && reportListingJsx()}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default AttachmentWiseProductivityReport;